import { render, staticRenderFns } from "./Secretary.vue?vue&type=template&id=a4dd2270&scoped=true"
import script from "./Secretary.vue?vue&type=script&lang=js"
export * from "./Secretary.vue?vue&type=script&lang=js"
import style0 from "./Secretary.vue?vue&type=style&index=0&id=a4dd2270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dd2270",
  null
  
)

export default component.exports